export enum PermissionTypes
{
  None = 0,
  View = 1,
  ManualTrigger = 2,
  DisableSchedule = 3,
  Query = 4,
  Credentials = 5,
  ViewCustomSchedules = 6,
  ManageCustomSchedules = 7,
  MarkRunAsErrored = 8,
  ManagePermissions = 9,
  ViewConfiguration = 10
}

